import { useFormikContext } from 'formik';
import GenerateFormHTMLNoValid from '../../../../component/generate-form/GenerateFormHTMLNoValid';

type Props = {
  title: string;
  formName: string; 
  dataGenerate?: any;
}

const ThongTinGiaDinh = (props: Props) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { dataGenerate, formName } = props;
  const isVisitStopped = values?.visit?.stopped;

  const handleChange = (name: string, value: any, type?: string) => {
    if (type === "select") {
      let stringName = name + "Name";
      let stringCode = name;
      setFieldValue(`additionalForms.${formName}`, {
        ...values?.additionalForms?.[formName],
        [stringName]: value?.name,
        [stringCode]: value?.code,
      });
    } else {
      setFieldValue(`additionalForms.${formName}.${name}`, value);
    }
  }

  return (
    <div className='tt-gia-dinh'>
      <div className="title">
        {props?.title}
      </div>
      <div className='content spaces pb-8 px-16'>
        <GenerateFormHTMLNoValid
          isView={isVisitStopped}
          listFieldAuto={dataGenerate}
          onChange={handleChange}
          values={values?.additionalForms}
          modelID={formName}
        />
      </div>
    </div>
  )
}

export default ThongTinGiaDinh